<div class="spinnerContainer" *ngIf="show">
    <div>
        <p-progressSpinner strokeWidth="6"></p-progressSpinner>
    </div>
</div>
